<template>
	<div class="fixed-price-channel-rule">
		<div class="page-info">
			<span class="info-tag">一口价选渠道-通用规则</span>
			适用于商品配置的「一口价选渠道-通用规则」，此规则只更新线上商品库存，不更新商品价格，店铺：
			<span class="shop-name">{{ shopName }}</span>
		</div>

		<div class="page-tips">
			<p class="tips-hint">提示：对于退货政策为100%+0%的渠道综合代理价=代理价；对于退货政策为0%+100%的渠道综合代理价=代理价*(1+渠道不支持退货代理价加点/100)；</p>
			<p class="tips-hint">提示：对于其他退货政策的渠道综合代理价计算方式，得分=50+免费退货比例/100*50+(4/100-超出扣款比率/100)*400，加价百分比=(1-得分/100)*渠道不支持退货代理价加点/100，渠道综合代理价=代理价*(1+加价百分比)</p>
			<p class="tips-hint">提示：渠道不支持退货代理价加点，对于退货政策为0%+100%的渠道代理价加价比率，如代理价为100，当前设定参数为5，则综合代理价为105，计算{{ platformName }}商品价格以105为准</p>
		</div>

		<el-form ref="form" v-loading="loading" :model="form" :rules="rules" label-width="220px" class="config-form">
			<div class="form-block">
				<el-form-item label="单款尺码毛利润 (%)" prop="grossProfit">
					<div class="field-wrap">
						<el-input-number v-model="form.grossProfit" :min="0" :precision="2" :controls="false" placeholder="0.00" />
						<p class="field-tip">若设置了阶梯毛利润，则以阶梯毛利润为准</p>
					</div>
				</el-form-item>
				<el-form-item label="渠道不支持退货代理价加点 (%)" prop="nonReturnMarkup">
					<div class="field-wrap">
						<el-input-number v-model="form.nonReturnMarkup" :min="0" :precision="2" :controls="false" placeholder="0.00" />
						<p class="field-tip">针对 0%+100% 退货政策渠道的加价比例；例如代理价 100、加点 5，综合代理价 105</p>
					</div>
				</el-form-item>
				<el-form-item label="不退渠道折扣大于多少不推库存" prop="nonReturnDiscount">
					<div class="field-wrap">
						<el-input-number v-model="form.nonReturnDiscount" :min="0" :precision="2" :controls="false" placeholder="0.00" />
						<p class="field-tip">仅针对 0%+100% 退货政策渠道，0 表示不控制，10 表示不打折</p>
					</div>
				</el-form-item>
				<el-form-item :label="platformDeductionLabel" prop="pddDeduction">
					<div class="field-wrap">
						<el-input-number v-model="form.pddDeduction" :min="0" :precision="2" :controls="false" placeholder="0.00" />
						<p class="field-tip">用于价格计算逻辑，与订单管理盈利无关</p>
					</div>
				</el-form-item>
				<el-form-item label="运费" prop="postage">
					<div class="field-wrap">
						<el-input-number v-model="form.postage" :min="0" :precision="2" :controls="false" placeholder="0.00" />
					</div>
				</el-form-item>
				<el-form-item label="配货率 (%)" prop="allocationRate">
					<div class="field-wrap">
						<el-input-number v-model="form.allocationRate" :min="0" :precision="2" :controls="false" placeholder="0.00" />
						<p class="field-tip">低于该配货率的渠道不推送</p>
					</div>
				</el-form-item>
				<el-form-item label="准时率 (%)" prop="onTimeRate">
					<div class="field-wrap">
						<el-input-number v-model="form.onTimeRate" :min="0" :precision="2" :controls="false" placeholder="0.00" />
						<p class="field-tip">低于该准时率的渠道不推送</p>
					</div>
				</el-form-item>
				<el-form-item label="预发日期" prop="shipDays">
					<div class="field-wrap">
						<el-select v-model="form.shipDays" placeholder="请选择">
							<el-option
								v-for="item in shipDateOptions"
								:key="item.value"
								:label="item.label"
								:value="item.value"
							/>
						</el-select>
						<p class="field-tip">渠道预发日期超过此值的不推送</p>
					</div>
				</el-form-item>
				<el-form-item label="退货政策" prop="returnPolicy">
					<el-radio-group v-model="form.returnPolicy" class="radio-group">
						<el-radio label="none">不做控制</el-radio>
						<el-radio label="exclude0_100">自动匹配渠道时，不匹配退货政策 0%+100% 的渠道</el-radio>
						<el-radio label="only100_0">自动匹配渠道时，只匹配退货政策 100%+0% 的渠道</el-radio>
					</el-radio-group>
				</el-form-item>
			</div>

			<div class="form-block form-block--divider">
				<el-form-item label="撕防伪状态" prop="securityStatus">
					<el-radio-group v-model="form.securityStatus">
						<el-radio label="all">全部</el-radio>
						<el-radio label="tear">撕防伪</el-radio>
						<el-radio label="no_tear">不撕防伪</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="渠道集" prop="channelSet">
					<el-radio-group v-model="form.channelSet">
						<el-radio label="all">全部</el-radio>
						<el-radio label="mandatory_backup">必选渠道+备选渠道</el-radio>
					</el-radio-group>
				</el-form-item>
			</div>

			<div class="tier-section">
				<div class="tier-header">
					<div class="tier-header-main">
						<span class="tier-title">阶梯毛利润配置</span>
						<span class="tier-note">若设置了阶梯利润，则以阶梯利润为准</span>
					</div>
					<el-button type="text" class="tier-add-btn" @click="onAddTier">+ 新增</el-button>
				</div>
				<div class="tier-table">
					<div class="tier-row tier-row--head">
						<span class="col-range">{{ priceRangeLabel }}</span>
						<span class="col-profit">毛利润 (%)</span>
						<span class="col-action">操作</span>
					</div>
					<div v-for="(item, index) in form.tierList" :key="item._uid" class="tier-row">
						<div class="col-range">
							<el-input-number v-model="item.priceMin" :min="0" :precision="2" :controls="false" placeholder="最低价" size="small" />
							<span class="range-sep">≤ {{ priceUnitLabel }} &lt;</span>
							<el-input-number v-model="item.priceMax" :min="0" :precision="2" :controls="false" placeholder="最高价" size="small" />
						</div>
						<div class="col-profit">
							<el-input-number v-model="item.profitRate" :min="0" :precision="2" :controls="false" placeholder="毛利润(%)" size="small" />
						</div>
						<div class="col-action">
							<span class="action-link" @click="onRemoveTier(index)">删除</span>
						</div>
					</div>
				</div>
			</div>

			<div class="form-actions">
				<el-button type="primary" :loading="saving" @click="onSave">保存</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
import {
	buildFixedPriceChannelSavePayload,
	buildGoodsFixedPriceChannelSavePayload,
	fetchGoodsPushConfig,
	fetchPushConfig,
	getProductPushConfigId,
	getRetailShopId,
	isProductPushConfigScope,
	mapFixedPriceChannelConfigToForm,
	PUSH_CONFIG_TYPES,
	saveGoodsPushConfig,
	savePushConfig,
	validateProfitTierList,
} from './retailShopPushConfig'
import taobaoPlatformMixin from './taobaoPlatformMixin'

let nextTierUid = 1

const createTierRow = () => ({
	_uid: nextTierUid++,
	priceMin: undefined,
	priceMax: undefined,
	profitRate: undefined,
})

const DEFAULT_TIER_COUNT = 2

const DEFAULT_FORM = {
	grossProfit: 5,
	nonReturnMarkup: 0,
	nonReturnDiscount: 0,
	pddDeduction: 0,
	postage: 10,
	allocationRate: 90,
	onTimeRate: 90,
	shipDays: 3,
	returnPolicy: 'only100_0',
	securityStatus: 'all',
	channelSet: 'all',
	is_enabled: 1,
	tierList: Array.from({ length: DEFAULT_TIER_COUNT }, createTierRow),
}

export default {
	name: 'FixedPriceChannelRule',
	mixins: [taobaoPlatformMixin],
	inject: {
		retailShop: { default: null },
	},
	data() {
		return {
			loading: false,
			saving: false,
			form: JSON.parse(JSON.stringify(DEFAULT_FORM)),
			rules: {
				grossProfit: [{ required: true, message: '请填写单款尺码毛利润', trigger: 'blur' }],
				nonReturnMarkup: [{ required: true, message: '请填写代理价加点', trigger: 'blur' }],
				nonReturnDiscount: [{ required: true, message: '请填写不退渠道折扣阈值', trigger: 'blur' }],
				pddDeduction: [{ required: true, message: '请填写扣点数', trigger: 'blur' }],
				postage: [{ required: true, message: '请填写运费', trigger: 'blur' }],
				allocationRate: [{ required: true, message: '请填写配货率', trigger: 'blur' }],
				onTimeRate: [{ required: true, message: '请填写准时率', trigger: 'blur' }],
				shipDays: [{ required: true, message: '请选择预发日期', trigger: 'change' }],
				returnPolicy: [{ required: true, message: '请选择退货政策', trigger: 'change' }],
				securityStatus: [{ required: true, message: '请选择撕防伪状态', trigger: 'change' }],
				channelSet: [{ required: true, message: '请选择渠道集', trigger: 'change' }],
			},
			shipDateOptions: [
				{ value: 1, label: '当日发货' },
			].concat(Array.from({ length: 14 }, (_, i) => ({
				value: i + 2,
				label: `${i + 2}日内发货`,
			}))),
		}
	},
	computed: {
		shopName() {
			return (this.retailShop && this.retailShop.shopName) || ''
		},
		configFetchKey() {
			if (!this.retailShop) {
				return ''
			}
			if (this.retailShop.pushConfigKey) {
				return this.retailShop.pushConfigKey
			}
			return this.retailShop.currentShopId || ''
		},
	},
	watch: {
		configFetchKey: {
			immediate: true,
			handler(key) {
				if (key) {
					this.fetchConfig()
				} else {
					this.resetForm()
				}
			},
		},
	},
	methods: {
		resetForm() {
			this.form = JSON.parse(JSON.stringify(DEFAULT_FORM))
		},
		applyConfig(data) {
			const mapped = mapFixedPriceChannelConfigToForm(data, createTierRow, DEFAULT_TIER_COUNT)
			const form = JSON.parse(JSON.stringify(DEFAULT_FORM))
			let key
			for (key in mapped) {
				if (mapped[key] !== undefined) {
					form[key] = mapped[key]
				}
			}
			if (mapped.tierList) {
				form.tierList = mapped.tierList.map(function(item) {
					return Object.assign(createTierRow(), item)
				})
			}
			this.form = form
		},
		fetchConfig() {
			const configType = PUSH_CONFIG_TYPES.FIXED_PRICE_CHANNEL
			if (isProductPushConfigScope(this.retailShop)) {
				const productId = getProductPushConfigId(this.retailShop)
				if (!productId) {
					return
				}
				this.loading = true
				fetchGoodsPushConfig(this.$axios, productId, configType).then(data => {
					this.applyConfig(data)
				}).catch(err => {
					console.log(err)
					this.$message.error(err.message || '获取一口价选渠道配置失败')
				}).finally(() => {
					this.loading = false
				})
				return
			}
			const shopId = getRetailShopId(this.retailShop)
			if (!shopId) {
				return
			}
			this.loading = true
			fetchPushConfig(this.$axios, shopId, configType).then(data => {
				this.applyConfig(data)
			}).catch(err => {
				console.log(err)
				this.$message.error(err.message || '获取一口价选渠道配置失败')
			}).finally(() => {
				this.loading = false
			})
		},
		onAddTier() {
			this.form.tierList.push(createTierRow())
		},
		onRemoveTier(index) {
			if (this.form.tierList.length <= 1) {
				this.$message.warning('至少保留一条阶梯配置')
				return
			}
			this.form.tierList.splice(index, 1)
		},
		onSave() {
			this.$refs.form.validate((valid) => {
				if (!valid) return
				const tierCheck = validateProfitTierList(this.form.tierList)
				if (!tierCheck.valid) {
					this.$message.warning(tierCheck.message)
					return
				}
				let payload
				if (isProductPushConfigScope(this.retailShop)) {
					const productId = getProductPushConfigId(this.retailShop)
					if (!productId) {
						this.$message.warning('商品信息不完整')
						return
					}
					payload = buildGoodsFixedPriceChannelSavePayload(productId, this.form)
				} else {
					const shopId = getRetailShopId(this.retailShop)
					if (!shopId) {
						this.$message.warning('店铺信息不完整')
						return
					}
					payload = buildFixedPriceChannelSavePayload(shopId, this.form)
				}
				this.saving = true
				const saveRequest = isProductPushConfigScope(this.retailShop)
					? saveGoodsPushConfig(this.$axios, payload)
					: savePushConfig(this.$axios, payload)
				saveRequest.then(() => {
					this.fetchConfig()
					this.$message.success('保存成功')
				}).catch(err => {
					console.log(err)
					this.$message.error(err.message || '保存失败')
				}).finally(() => {
					this.saving = false
				})
			})
		},
	},
}
</script>

<style scoped lang="less">
.fixed-price-channel-rule {
	padding: 24px 28px 40px;
	background: #fff;
	min-height: 100%;
	box-sizing: border-box;
}

.page-info {
	margin-bottom: 20px;
	padding: 14px 18px;
	font-size: 14px;
	line-height: 1.6;
	color: #606266;
	background: #fafbfc;
	border-left: 3px solid #67c23a;
	border-radius: 0 6px 6px 0;

	.info-tag {
		display: inline-block;
		margin-right: 8px;
		padding: 2px 10px;
		font-size: 12px;
		color: #409eff;
		background: rgba(64, 158, 255, 0.08);
		border-radius: 3px;
		vertical-align: middle;
	}

	.shop-name {
		color: #ff4714;
		font-weight: 500;
	}
}

.page-tips {
	margin-bottom: 28px;
	padding: 14px 18px;
	background: #fafbfc;
	border-radius: 6px;
	border: 1px solid #f0f2f5;

	.tips-subtitle {
		margin: 0 0 8px;
		font-size: 13px;
		font-weight: 500;
		color: #606266;

		& + .tips-list {
			margin-bottom: 14px;
		}
	}

	.tips-list {
		margin: 0 0 14px;
		padding-left: 18px;
		font-size: 13px;
		line-height: 1.9;
		color: #909399;

		li {
			margin: 0;
		}
	}

	.tips-example {
		margin: 0;
		padding-top: 10px;
		border-top: 1px dashed #ebeef5;
		font-size: 12px;
		color: #b0b3b8;
		line-height: 1.7;
	}

	.tips-hint {
		margin: 0 0 8px;
		font-size: 13px;
		line-height: 1.8;
		color: #f56c6c;

		&:last-of-type {
			margin-bottom: 0;
		}
	}
}

.config-form {
	max-width: 820px;

	/deep/ .el-form-item {
		margin-bottom: 18px;
	}

	/deep/ .el-form-item__label {
		font-size: 12px;
		color: #606266;
		line-height: 36px;
		padding-right: 16px;
	}

	/deep/ .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::before {
		color: #f56c6c;
	}
}

.form-block {
	&--divider {
		margin-top: 8px;
		padding-top: 24px;
		border-top: 1px solid #f2f3f5;
	}
}

.field-wrap {
	max-width: 360px;

	.el-input,
	.el-select,
	.el-input-number {
		width: 100%;
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}

	/deep/ .el-input__inner {
		height: 36px;
		line-height: 36px;
		border-color: #e8eaed;
		border-radius: 4px;
		background: #fafbfc;
		transition: all 0.2s;

		&:hover {
			border-color: #dcdfe6;
			background: #fff;
		}

		&:focus {
			border-color: #ff4714;
			background: #fff;
		}
	}
}

.field-tip {
	margin: 6px 0 0;
	font-size: 11px;
	color: #b0b3b8;
	line-height: 1.5;
}

.radio-group {
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding-top: 10px;

	/deep/ .el-radio {
		margin-right: 0;
		line-height: 1.6;
		white-space: normal;
	}
}

.tier-section {
	margin-top: 28px;
	padding-top: 24px;
	border-top: 1px solid #f2f3f5;
}

.tier-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	margin-bottom: 16px;
}

.tier-header-main {
	display: flex;
	align-items: baseline;
	gap: 12px;
	min-width: 0;
}

.tier-add-btn {
	padding: 0;
	font-size: 12px;
	color: #ff4714;

	&:hover {
		color: #ff4714;
		opacity: 0.75;
	}
}

.action-link {
	font-size: 13px;
	color: #ff4714;
	cursor: pointer;
	transition: opacity 0.2s;

	&:hover {
		opacity: 0.7;
	}
}

.tier-title {
	font-size: 14px;
	font-weight: 500;
	color: #303133;
}

.tier-note {
	font-size: 12px;
	color: #b0b3b8;
}

.tier-table {
	border: 1px solid #f0f2f5;
	border-radius: 6px;
	overflow: hidden;
}

.tier-row {
	display: flex;
	align-items: center;
	padding: 12px 16px;
	border-bottom: 1px solid #f5f6f8;

	&:last-child {
		border-bottom: none;
	}

	&--head {
		background: #fafbfc;
		font-size: 13px;
		color: #909399;
		font-weight: 500;
		padding: 10px 16px;
	}
}

.col-range {
	flex: 1;
	display: flex;
	align-items: center;
	gap: 10px;
	min-width: 0;

	.el-input,
	.el-input-number {
		width: 120px;
		flex-shrink: 0;
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}
}

.range-sep {
	font-size: 13px;
	color: #909399;
	white-space: nowrap;
	flex-shrink: 0;
}

.col-profit {
	width: 160px;
	flex-shrink: 0;

	.el-input,
	.el-input-number {
		width: 100%;
	}

	/deep/ .el-input-number .el-input__inner {
		text-align: left;
	}
}

.col-action {
	width: 72px;
	flex-shrink: 0;
	text-align: center;
}

.form-actions {
	display: flex;
	justify-content: flex-end;
	margin-top: 32px;
	padding-top: 24px;
	border-top: 1px solid #f2f3f5;

	.el-button {
		min-width: 96px;
		height: 36px;
		padding: 0 24px;
		font-size: 12px;
		border-radius: 4px;
		letter-spacing: 1px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/StoreConfig/detailed/fixedPriceChannelRule.vue